/**
 * ToyBox Wishlist Module
 * localStorage-based wishlist with heart toggle on product cards and product page.
 */
window.ToyBox = window.ToyBox || {};

ToyBox.wishlist = (function () {
  'use strict';

  function getString(key, fallback) {
    return ToyBox.strings && ToyBox.strings.wishlist && ToyBox.strings.wishlist[key] || fallback;
  }

  var STORAGE_KEY = 'toybox:wishlist';

  var HEART_EMPTY =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';

  var HEART_FILLED =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#E63946" stroke="#E63946" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';

  function getHandles() {
    try {
      var data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : [];
    } catch (e) {
      return [];
    }
  }

  function saveHandles(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {
      // Storage full or unavailable
    }
  }

  function isInWishlist(handle) {
    return getHandles().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var handles = getHandles();
    var index = handles.indexOf(handle);
    if (index === -1) {
      handles.push(handle);
    } else {
      handles.splice(index, 1);
    }
    saveHandles(handles);
    document.dispatchEvent(new CustomEvent('toybox:wishlist-changed'));
    return index === -1; // true if added, false if removed
  }

  function getCount() {
    return getHandles().length;
  }

  function syncBadge() {
    var count = getCount();
    var badges = document.querySelectorAll('[data-wishlist-count]');
    badges.forEach(function (el) {
      if (count > 0) {
        el.textContent = count < 100 ? count : '';
        el.style.display = '';
        if (el.parentElement && el.parentElement.classList.contains('wishlist-count-bubble')) {
          el.parentElement.style.display = '';
        }
      } else {
        el.style.display = 'none';
        if (el.parentElement && el.parentElement.classList.contains('wishlist-count-bubble')) {
          el.parentElement.style.display = 'none';
        }
      }
    });
  }

  function syncButtons() {
    var buttons = document.querySelectorAll('[data-wishlist-toggle]');
    buttons.forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      var inList = isInWishlist(handle);
      btn.setAttribute('aria-pressed', inList ? 'true' : 'false');
      btn.innerHTML = inList ? HEART_FILLED : HEART_EMPTY;
    });

    // Sync product page button if it exists
    var pdpBtn = document.querySelector('.wishlist-pdp-toggle');
    if (pdpBtn) {
      var pdpHandle = pdpBtn.getAttribute('data-product-handle');
      var pdpInList = isInWishlist(pdpHandle);
      pdpBtn.setAttribute('aria-pressed', pdpInList ? 'true' : 'false');
      var pdpSvg = pdpBtn.querySelector('.wishlist-pdp-icon');
      if (pdpSvg) {
        pdpSvg.innerHTML = pdpInList ? HEART_FILLED : HEART_EMPTY;
      }
      var pdpText = pdpBtn.querySelector('.wishlist-pdp-text');
      if (pdpText) {
        pdpText.textContent = pdpInList ? getString('inWishlist', 'In Your Wishlist') : getString('add', 'Add to Wishlist');
      }
    }

    syncBadge();
  }

  function injectProductPageButton() {
    if (!window.location.pathname.startsWith('/products/')) return;

    var pathParts = window.location.pathname.split('/');
    var handle = pathParts[pathParts.length - 1];
    if (!handle) return;

    var buttonsContainer = document.querySelector('.product-form__buttons');
    if (!buttonsContainer) return;

    // Don't inject twice
    if (document.querySelector('.wishlist-pdp-toggle')) return;

    var inList = isInWishlist(handle);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wishlist-pdp-toggle';
    btn.setAttribute('data-product-handle', handle);
    btn.setAttribute('aria-pressed', inList ? 'true' : 'false');
    btn.setAttribute('aria-label', getString('toggle', 'Toggle wishlist'));
    btn.innerHTML =
      '<span class="wishlist-pdp-icon">' +
      (inList ? HEART_FILLED : HEART_EMPTY) +
      '</span>' +
      '<span class="wishlist-pdp-text">' +
      (inList ? getString('inWishlist', 'In Your Wishlist') : getString('add', 'Add to Wishlist')) +
      '</span>';

    btn.addEventListener('click', function () {
      toggle(handle);
      syncButtons();
    });

    buttonsContainer.parentNode.insertBefore(btn, buttonsContainer.nextSibling);
  }

  function init() {
    syncButtons();
    injectProductPageButton();

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute('data-product-handle');
      toggle(handle);
      syncButtons();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  return {
    getHandles: getHandles,
    isInWishlist: isInWishlist,
    toggle: toggle,
    getCount: getCount,
    syncButtons: syncButtons,
  };
})();
